<div *ngIf="data$ | async as data" class="dashboard-chart-wrapper">
  <p-chart
    type="line"
    [data]="data"
    [options]="options"
    [plugins]="plugins"
    style="width: 100%; height: 100%"
  ></p-chart>
</div>
